import { useEffect } from 'react';
import { safeMapResize } from '../utils/safeMapResize';

/**
 * 侧栏收缩 / 页面可见性 / 标题栏变化时触发地图 resize
 */
export default function useDashboardMapChromeEffects({ getMap, collapsed }) {
  useEffect(() => {
    const map = getMap?.();
    if (!map) return undefined;
    const timer = setTimeout(() => safeMapResize(getMap?.()), 350);
    return () => clearTimeout(timer);
  }, [collapsed, getMap]);

  useEffect(() => {
    let timer = null;
    const handleVisibilityChange = () => {
      if (document.hidden) return;
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (safeMapResize(getMap?.())) {
          console.log('页面可见性变化，地图已重新调整大小');
        }
      }, 100);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [getMap]);

  useEffect(() => {
    let timer = null;
    const checkTitleBarState = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (safeMapResize(getMap?.())) {
          console.log('Dashboard地图已重新调整大小，适应标题栏状态变化');
        }
      }, 100);
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          checkTitleBarState();
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [getMap]);
}
